import axios from '@axios'

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // ------------------------------論壇前台系統---------------------------------
    // (獲取)儲存資源
    getLocalConfig() {
      return new Promise((resolve, reject) => {
        axios
          .get('/forum-config.json')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    // (獲取)儲存資源
    getForumConfig(store, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`https://forum.web-hosts.net/api/web/forum/class/${params.id}`, {
            params: {
              limit: params.limit,
              page: params.page,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
